const Tools = {
	round: (p, n) => {
		return p - (p % n);
	}
};
export default Tools;
